import useSWR from 'swr';

import useQueryString from '@/hooks/useQueryString';
import { fetcher } from '@/helpers/fetcher';
import {
  API_HOSTNAME as API,
  API_TABLE_TYPE as T,
  ACTION_GET_TYPE as G,
  FOCUS_THROTTLE_INTERVAL,
} from '@/constants/api';

/**
 * @function useGuestInfo
 * @description a custom hook to get guest information
 */
function useGuestInfo(code) {
  const { getQueryValue } = useQueryString();
  const guestCode = code || getQueryValue('code');
  const finalURL = API + `?action=${G.readQrCode}&table_name=${T.rsvp}&guest_code=${guestCode}`;

  const { data, isLoading, error, mutate } = useSWR(guestCode ? finalURL : null, fetcher, {
    focusThrottleInterval: FOCUS_THROTTLE_INTERVAL,
  });

  const rawData = data?.data || {};
  const isCompleted = guestCode ? (typeof data?.success === 'undefined' ? false : true) : true;

  const EMPTY_DEFAULT = {
    code: '',
    name: '',
    desc: '',
    vip_text: '',
    is_group_link: false,
    is_active: 0,
  };

  const guestData = {
    code: rawData.CODE || '',
    name: rawData.NAME || '',
    desc: String(rawData.DESC) || '',
    shift: rawData.SHIFT || '',
    address: rawData.ADDRESS || '',
    country_code: rawData.COUNTRY_CODE || '',
    phone_number: rawData.PHONE_NUMBER || '',
    email: rawData.EMAIL || '',
    guest_quota: rawData.GUEST_QUOTA || rawData.GUEST_QUOTA || 1,
    guest_confirm: rawData.GUEST_CONFIRM || 0,
    guest_left: rawData.GUEST_LEFT || 0,
    status: rawData.STATUS || '',
    attend_info: rawData.ATTEND_INFO || '',
    system_info: rawData.SYSTEM_INFO || '',
    last_update: rawData.LAST_UPDATE || '',
    is_active: rawData.IS_ACTIVE,
    is_group_link: rawData.TYPE === 'GROUP',
    vip_text: String(rawData.VIP_TEXT) || '',
  };

  if (error || !data?.success || isLoading || guestData.is_active === 0) {
    return {
      ...EMPTY_DEFAULT,
      isLoading,
      isCompleted,
      isRegistered: false,
      onRefetchGuest: mutate,
    };
  }

  // IF the loadigng is completed
  // and there's no errors and also the guest is actived
  // then return the normalizer data
  return { ...guestData, isLoading, isCompleted, isRegistered: true, onRefetchGuest: mutate };
}

export default useGuestInfo;
